
import { Component, Prop, Vue } from "vue-property-decorator";
import WidgetData from "@/interfaces/dashboard/WidgetData";

@Component
export default class Number extends Vue {
  @Prop({ default: {} })
  public widgetData: WidgetData;
}
